import { useIntl } from 'react-intl';
import { Divider, Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import ReleaseForm from '@/components/Registry/BillToPay/ReleaseForm';
import {
  AccountPayableReleaseFormValues,
  AccountPayableReleaseRequest,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { useInstallmentCreate } from '@/core/domain/financial/AccountPayable/AccountPayable.hooks';
import { useHistory } from 'react-router-dom';
import { DateTimeFormat } from '@/utils/moment';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { queryClient } from '@/Root';

function ReleasesCreatePage({ route }: PageProps) {
  const intl = useIntl();
  const history = useHistory();

  const search = queryClient.getQueryData(['billsToPay', 'search']);

  const [form] = Form.useForm<AccountPayableReleaseFormValues>();

  const createMutation = useInstallmentCreate();

  const handleCreateInstallment = async () => {
    const values = await form.validateFields();

    const obj: AccountPayableReleaseRequest = {
      ...values,
      emissionDate: values.emissionDate.format(DateTimeFormat),
      dueDate: !!values.dueDate
        ? values.dueDate.format(DateTimeFormat)
        : undefined,
      installmentNumber: values.installmentNumber || 1,
      intervalDays: values.intervalDays || 0,
      description: values.description ?? '',
    };

    const response = await createMutation.mutateAsync(obj);

    history.push(
      `/app/financial/billToPay/releaseBillToPay/detail/accountPayableId/${response.id}/installmentPayableId/${response.installmentPayable.id}`,
    );
  };

  return (
    <TabContentWrapper
      title={route.name}
      permissions={route.permissions}
      extra={
        <SaveButton
          type="primary"
          onClick={handleCreateInstallment}
          loading={createMutation.isLoading}
          block
          disabled={
            !hasPermissions([
              Authorities.FINANCIAL_ACCOUNT_PAYABLE_GENERATE_ACCOUNTS_PAYABLE,
            ])
          }
        >
          {intl.formatMessage({ id: 'commons.form.button.save' })}
        </SaveButton>
      }
    >
      <ReleaseForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack
          path={`/app/financial/billToPay/releaseBillToPay?${search ?? ''}`}
        />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default ReleasesCreatePage;
